import React from 'react';
import { Star } from 'src/components/shared/Star';

interface FollowingStarProps {
  size: number;
  isFollowing: boolean;
}

export const FollowingStar: React.FC<FollowingStarProps> = ({ size, isFollowing }) => {
  const innerColor = isFollowing ? '#ffc700' : '#f1e9d2';
  const strokeColor = isFollowing ? '#ad8700' : '#d4c69b';
  return <Star size={size} innerColor={innerColor} strokeColor={strokeColor} />;
};
